import { AuthError } from 'next-auth';

class InvalidCredentials extends AuthError {
    public readonly kind = 'signIn';

    constructor() {
        super('Geçersiz oturum bilgileri. Lütfen tekrar kontrol edin.');
        this.type = 'CredentialsSignin';
    }
}

export { InvalidCredentials }